"use client";
import {useState} from "react";
import Number from "./Number";
import {useFrontendConfiguratorContext} from "../../ProductConfigurator/context";
import Image from "next/image";




import icon_height_dx from "public/images/height_dx.jpg";
import icon_height_sx from "public/images/height_sx.jpg";
import icon_width_up from "public/images/width_up.jpg";
import icon_width_dw from "public/images/width_dw.jpg";
import {usePhrase} from "../../../i18n";

const normalizeSku = (sku) => {
    return sku.replace(/[^a-zA-Z0-9]/g, '_');
}

const MeasuresBox = ({heightOpt, height2Opt, widthOpt, width2Opt, showErrors, currency,onChange, _t}) => {
    const [optionsEdited, setOptionsEdited] = useState({});
    const [editedTimer, setEditedTimer] = useState(null);

    const {currentConfiguration,
    itemId} = useFrontendConfiguratorContext();

    const t = usePhrase(_t);
    const reflectChange = (sourceOption, targetOption, val) => {

       //console.log('reflectChange', sourceOption, targetOption, val);

        if (onChange)
            onChange({name: sourceOption.option_id, value: val});

        if(itemId) return;

        if (editedTimer) {
            clearTimeout(editedTimer);
            setEditedTimer(null);
        }

        let timer = setTimeout(() => {
            setOptionsEdited({...optionsEdited, [sourceOption.option_id]: true});
        }, 600);

        setEditedTimer(timer);


        //let prevValue = currentConfiguration.options.find(o => o.option_id === targetOption.option_id);

        if (targetOption && optionsEdited[targetOption.option_id]/* || (prevValue && (prevValue!=='' || prevValue.value === val))*/) return;

        //if (prevValue  && (prevValue!=='' || prevValue === val)) return;

        if (onChange && targetOption)
            onChange({name: targetOption.option_id, value: val});

    }

    return <div className={`flex flex-col`}>
        {(widthOpt || width2Opt) && <div className={`flex-1 lg:mb-3`}>
            <div className={`flex flex-col lg:flex-row lg:space-x-1.5 `}>
                {widthOpt && <div className={`mb-3  lg:mb-0 lg:flex-1`}>
                    <h3 className={'font-bold mb-0.5 capitalize'}>{widthOpt.title}{widthOpt.is_require=="1" && "*"}:</h3>
                    <Number key={'opt_input_' + widthOpt.option_id}
                            id={`field_option_${normalizeSku(widthOpt.sku)}`}
                            option={widthOpt}
                            value={currentConfiguration?.options.find(opt => opt.option_id === widthOpt.option_id)?.value}
                            currency={currency}
                            showErrors={showErrors}
                            min={0}
                            showLabel={false}
                            prefix={<div className={'flex justify-between'}>

                                <Image
                                    src={icon_width_up}
                                    alt={` ${t('icon')} ${widthOpt.title}`}
                                    height={40}
                                    width={40}
                                    sizes={'40px'}
                                    />


                            </div>}
                            suffix={<div><p>mm</p></div>}
                            onChange={(val) => reflectChange(widthOpt, width2Opt, val.value)}/>
                    {showErrors && currentConfiguration?.errors && currentConfiguration.errors.filter(e => e.option_id === widthOpt.option_id).map((error, errorIndex) => {
                        return <p key={['conf','option',widthOpt.option_id,'error',errorIndex].join('_')} className={'text-red-500 text-xs'}>{error.message}</p>
                    })}
                </div>}
                {width2Opt && <div className={`mb-3 lg:mb-0 lg:flex-1`}>
                    <h3 className={'font-bold mb-0.5 capitalize'}>{width2Opt.title}{width2Opt.is_require=="1" && "*"}:</h3>
                    <Number key={'opt_input_' + width2Opt.option_id}
                            id={`field_option_${normalizeSku(width2Opt.sku)}`}
                            option={width2Opt}
                            value={currentConfiguration?.options.find(opt => opt.option_id === width2Opt.option_id)?.value}
                            currency={currency}
                            showErrors={showErrors}
                            min={0}
                            showLabel={false}
                            prefix={<div className={'flex justify-between'}>

                                <Image
                                    src={icon_width_dw}
                                    alt={` ${t('icon')} ${width2Opt.title}`}
                                    height={40}
                                    width={40}
                                    sizes={'40px'}
                                    />


                            </div>}
                            suffix={<div><p>mm</p></div>}
                            onChange={(val) => reflectChange(width2Opt, widthOpt, val.value)}/>
                    {showErrors && currentConfiguration?.errors && currentConfiguration.errors.filter(e => e.option_id === width2Opt.option_id).map((error, errorIndex) => {
                        return <p key={['conf','option',width2Opt.option_id,'error',errorIndex].join('_')} className={'text-red-500 text-xs'}>{error.message}</p>
                    })}
                </div>}
            </div>
        </div>}
        {(heightOpt || height2Opt) && <div className={`flex-1 lg:mb-3`}>
            <div className={`flex flex-col lg:flex-row lg:space-x-1.5 `}>
                {heightOpt && <div className={`mb-3 lg:mb-0 lg:flex-1`}>
                    <h3 className={'font-bold mb-0.5 capitalize'}>{heightOpt.title}{heightOpt.is_require=="1" && "*"}:</h3>
                    <Number key={'opt_input_' + heightOpt.option_id}
                            id={`field_option_${normalizeSku(heightOpt.sku)}`}
                            option={heightOpt}
                            value={currentConfiguration?.options.find(opt => opt.option_id === heightOpt.option_id)?.value}
                            currency={currency}
                            showErrors={showErrors}
                            min={0}
                            showLabel={false}
                            prefix={<div className={'flex justify-between'}>

                                <Image
                                    src={icon_height_sx}
                                    alt={` ${t('icon')} ${heightOpt.title}`}
                                    height={40}
                                    width={40}
                                    sizes={'40px'}
                                    />

                            </div>}
                            suffix={<div><p>mm</p></div>}
                            onChange={(val) => reflectChange(heightOpt, height2Opt, val.value)}/>
                    {showErrors && currentConfiguration?.errors && currentConfiguration.errors.filter(e => e.option_id === heightOpt.option_id).map((error, errorIndex) => {
                        return <p key={['conf','option',heightOpt.option_id,'error',errorIndex].join('_')} className={'text-red-500 text-xs'}>{error.message}</p>
                    })}
                </div>}
                {height2Opt && <div className={`mb-3 lg:mb-0 lg:flex-1`}>
                    <h3 className={'font-bold mb-0.5 capitalize'}>{height2Opt.title}{height2Opt.is_require=="1" && "*"}:</h3>
                    <Number key={'opt_input_' + height2Opt.option_id}
                            id={`field_option_${normalizeSku(height2Opt.sku)}`}
                            option={height2Opt}
                            value={currentConfiguration?.options.find(opt => opt.option_id === height2Opt.option_id)?.value}
                            currency={currency}
                            showErrors={showErrors}
                            min={0}
                            showLabel={false}
                            prefix={<div className={'flex justify-between'}>

                                <Image
                                    src={icon_height_dx}
                                    alt={` ${t('icon')} ${height2Opt.title}`}
                                    height={40}
                                    width={40}
                                    sizes={'40px'}
                                    />

                            </div>} suffix={<div><p>mm</p></div>}
                            onChange={(val) => reflectChange(height2Opt, heightOpt, val.value)}/>
                    {showErrors && currentConfiguration?.errors && currentConfiguration.errors.filter(e => e.option_id === height2Opt.option_id).map((error, errorIndex) => {
                        return <p key={['conf','option',height2Opt.option_id,'error',errorIndex].join('_')} className={'text-red-500 text-xs'}>{error.message}</p>
                    })}
                </div>}
            </div>

        </div>}

    </div>;

}

export default MeasuresBox;